import { notification } from 'antd'
import apiClient from 'services/axios'
import {
  assignTicketToAgentApi,
  createTicket,
  editTicketById,
  getActiveTicketsByUserId,
  getAllTechSupport,
  getAllTickets,
  getCommentsByTicketId,
  getTicketAttachmentById,
  getTicketsByAgent,
  getTicketsByUserId,
} from 'services/axios/ticketSystem/index'

export const ticketActions = {
  GET_TICKETS: 'GET_TICKETS',
  GET_ACTIVE_TICKETS: 'GET_ACTIVE_TICKETS',
  CREATE_TICKET: 'CREATE_TICKET',
  HANDLE_PAGINATION: 'HANDLE_TICKET_PAGINATION',
  TICKET_HANDLE_STATUS: 'TICKET_HANDLE_STATUS',
  EDIT_TICKET: 'EDIT_TICKET',
  GET_COMMENTS: 'GET_COMMENTS',
  GET_TICKET_ATTACHMENTS_BY_ID: 'GET_TICKET_ATTACHMENTS_BY_ID',
  GET_SINGLE_TICKET: 'GET_SINGLE_TICKET',
  GET_ALL_TECH_SUPPORT_USERS: 'GET_ALL_TECH_SUPPORT_USERS',
  DUMMY: 'DUMMY',
}

export const getTicketsAction = ({ skip, limit, status, priority, assignedTo }) => {
  return async (dispatch) => {
    try {
      const response = await getAllTickets({ skip, limit, status, priority, assignedTo })
      dispatch({
        type: ticketActions.GET_TICKETS,
        payload: {
          tickets: response?.data?.data?.tickets,
          totalCount: response?.data?.data?.totalCount,
        },
      })
    } catch (error) {
      console.error('Error fetching tickets:', error)
    }
  }
}

export const createTicketAction = (ticketData) => {
  return async (dispatch) => {
    try {
      const response = await createTicket(ticketData)
      dispatch({
        type: ticketActions.CREATE_TICKET,
        payload: response?.data?.data,
      })
      return response
    } catch (error) {
      console.error('Error creating ticket:', error)
      throw error
    }
  }
}

export const editTicketAction = (ticketId, ticketData) => {
  return async (dispatch) => {
    try {
      const response = await editTicketById(ticketId, ticketData)
      dispatch({
        type: ticketActions.EDIT_TICKET,
        payload: response?.data?.ticket,
      })
      notification.success({
        message: 'Ticket Updated',
        description: 'The ticket was updated successfully.',
      })
    } catch (error) {
      console.error('Error editing ticket:', error)
      notification.error({
        message: 'Update Failed',
        description: 'Could not update the ticket. Please try again.',
      })
    }
  }
}

export const uploadTicketAttachment = async (ticketId, file) => {
  const formData = new FormData()
  formData.append('file', file)
  return apiClient.post(`/ticket/${ticketId}/attachments`, formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
}

export const getTicketsByUserIdAction = ({ userId, skip, limit, status, priority, assignedTo }) => {
  return async (dispatch) => {
    try {
      const response = await getTicketsByUserId(userId, {
        skip,
        limit,
        status,
        priority,
        assignedTo,
      })
      dispatch({
        type: ticketActions.GET_TICKETS,
        payload: {
          tickets: response?.data?.data?.tickets,
          totalCount: response?.data?.data?.totalCount,
        },
      })
    } catch (error) {
      console.error('Error fetching user tickets:', error)
    }
  }
}
export const getActiveTicketsByUserIdAction = (userId) => {
  return async (dispatch) => {
    try {
      const response = await getActiveTicketsByUserId(userId)
      console.log('response for active tickets>>>', response)

      dispatch({
        type: ticketActions.GET_ACTIVE_TICKETS,
        payload: {
          Activetickets: response?.data?.data,
        },
      })
    } catch (error) {
      console.error('Error fetching user tickets:', error)
    }
  }
}
export const getSingleTicketAction = (ticketId) => {
  return async (dispatch) => {
    try {
      const response = await apiClient.get(`/ticket/single-tickets/${ticketId}`)
      dispatch({
        type: ticketActions.GET_SINGLE_TICKET,
        payload: response?.data?.data,
      })
    } catch (error) {
      console.error('Error fetching single ticket:', error)
    }
  }
}
// for attatchments
export const getAttachmentsById = (ticketId) => {
  return async (dispatch) => {
    try {
      const response = await getTicketAttachmentById(ticketId)
      dispatch({
        type: ticketActions.GET_TICKET_ATTACHMENTS_BY_ID, // Prefer a specific type for clarity
        payload: {
          attachments: response?.data || [], // adjust according to real API response
          totalCount: response?.totalCount || 0,
        },
      })
    } catch (error) {
      console.error('Error fetching ticket attachments:', error)
    }
  }
}

export const assignTicketToAgentAction = (ticketId, assignedTo) => {
  return async (dispatch) => {
    try {
      const response = await assignTicketToAgentApi(ticketId, assignedTo)
      dispatch({
        type: ticketActions.EDIT_TICKET,
        payload: response?.data?.data,
      })
      notification.success({
        message: 'Ticket Assigned',
        description: 'The ticket was assigned successfully.',
      })
    } catch (error) {
      notification.error({
        message: 'Assignment Failed',
        description: 'Could not assign the ticket. Please try again.',
      })
    }
  }
}

export const getTicketsByAgentAction = ({ agentId, skip, limit, status, priority }) => {
  return async (dispatch) => {
    try {
      const response = await getTicketsByAgent(agentId, { skip, limit, status, priority })
      dispatch({
        type: ticketActions.GET_TICKETS,
        payload: {
          tickets: response?.data?.data?.tickets,
          totalCount: response?.data?.data?.totalCount,
        },
      })
    } catch (error) {
      console.error('Error fetching agent tickets:', error)
    }
  }
}

export const getAllTechSupportUsers = () => {
  return async (dispatch) => {
    try {
      const response = await getAllTechSupport()
      dispatch({
        type: ticketActions.GET_ALL_TECH_SUPPORT_USERS,
        payload: response?.data || [],
      })
    } catch (error) {
      console.error('Error fetching tech support users:', error)
    }
  }
}

// for comments

export const getCommentsById = ({ ticketid }) => {
  return async (dispatch) => {
    try {
      const response = await getCommentsByTicketId(ticketid)
      dispatch({
        type: ticketActions.GET_COMMENTS,
        payload: {
          comments: response?.data?.data,
        },
      })
    } catch (error) {
      console.error('Error fetching user comments:', error)
    }
  }
}

export const handlePagination = (pagination) => {
  return {
    type: ticketActions.HANDLE_PAGINATION,
    payload: pagination,
  }
}

export const handleTicketStatus = (status) => ({
  type: ticketActions.TICKET_HANDLE_STATUS,
  payload: status,
})
